import BlogArticlePage from '../components/BlogArticles';
import { publicMeta } from './public-meta';

export const meta = publicMeta(
  'Movement is the last moat | Cartwheel',
  'Why movement, not language, may be the next defining frontier for intelligent machines.',
);

export default BlogArticlePage;
